import { IRoleAccess } from '../types';



export const policy: IRoleAccess = {
  sharedResource: {
    create: false,
    delete: false,
    update: false,
    view: false
  },
  superIntendent: {
    create: false,
    delete: true,
    update: true,
    view: true
  },
  admin: {
    create: false,
    delete: true,
    update: true,
    view: true
  },
  client: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  contractor: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  designer: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  staff: {
    create: false,
    delete: false,
    update: true,
    view: true
  }
};
